import React, { useContext, useEffect } from "react";
import { Dashboard } from "../layout";
import { Header, NavMenu } from "../components/body";
import { Navigate, Route, Routes, useNavigate } from "react-router-dom";
import { logo } from "../assets";

import {
  Home,
  AddEditProd,
  Products,
  Categories,
  Suppliers,
  AddEditSplr,
  Brands,
  Stocks,
  OrderAndReceiveForm,
  StockTransForm,
  RetailReport,
  AddEditCstmr,
  Customers,
  ViewCstmr,
  Groups,
  SettingsForm,
  Outlets,
  AddEditOutlet,
  PaymentTypes,
  Taxes,
  Users,
  AddEditUser,
  POS,
  SalesHistory,
  CashMgmts,
  Status,
  Quotes,
  SpecialOrderForm,
  SpecialOrders,
  StockReturns,
  StockReturnForm,
  Tags,
  ProdAttrs,
} from ".";
import ViewOrder from "./Inventory/Stock/ViewOrder/ViewOrder";
import ReceivedDeliveryForm from "./Inventory/Stock/ReceivedDeliveryForm/ReceivedDeliveryForm";
import Registers from "./Setup/Outlet/Register/Registers";
import CloseReg from "./Sales/POS/Register/CloseReg/CloseReg";
import ImportCatalog from "./Catalog/Product/ImportCatalog/ImportCatalog";
import { AppContext } from "../App";
import ViewSupplier from "./Catalog/Supplier/ViewSupplier/ViewSupplier";
import ViewReturnStock from "./Inventory/StockReturn/ViewReturn/ViewReturnStock";
import ProfitAndLoss from "./Report/ProfitAndLoss/ProfitAndLoss";
import CreditCustomer from "./Report/CreditCustomer/CreditCustomer";
import ProductMovement from "./Report/ProductMovement/ProductMovement";
import TrialBalance from "./Report/TrialBalance/TrialBalance";
import PrintLabelForm from "./Inventory/PrintProductLabel/PrintNewLabel/PrintLabelForm";
import PrintLabelHistory from "./Inventory/PrintProductLabel/PrintLabelHistory/PrintLabelHistory";
import { SellReturnForm } from "./Sales/SaleReturn";
import FollowUpTypes from "./CRM/FollowUpType/FollowUpTypes";
import InquerySources from "./CRM/InqSrcType/InquerySources";
import Inquiries from "./CRM/Inquery/Inquiries";
import AddEditInquiry from "./CRM/Inquery/AddEditInquiry";
import ViewInquiry from "./CRM/Inquery/ViewInquiry";
import { Currencies } from "./Setup/Currency";
import UserRoles from "./Setup/UserRole/UserRoles";
import {
  ChartOfAccounts,
  CreditNotes,
  DebitNotes,
  JournalVouchers,
} from "./Accounts";

const SiteRoute = () => {
  const navigate = useNavigate();
  const { authUser, access } = useContext(AppContext);

  useEffect(() => {
    // check user in the auth location?
    authUser && window.location.pathname === "/auth" && navigate("/home");
    return () => {};
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [authUser]);

  return (
    <Dashboard menu={<NavMenu />} header={<Header />} logo={logo}>
      <Routes>
        <Route
          path="/"
          element={<Navigate to={access.dashboardAccess ? "home" : "pos"} />}
        />
        {access.dashboardAccess && <Route path="/home" element={<Home />} />}

        {access.posAccess && <Route path="/pos/*" element={<POS />} />}
        {access.status && <Route path="/status" element={<Status />} />}
        {access.pos?.quote && <Route path="/quotes" element={<Quotes />} />}

        {/* ======== Accounts Routes ======== */}
        {access.cashMgmtAccess && (
          <Route path="/cash_management" element={<CashMgmts />} />
        )}
        <Route path="/debit_note" element={<DebitNotes />} />
        <Route path="/credit_note" element={<CreditNotes />} />
        <Route path="/journal_voucher" element={<JournalVouchers />} />
        <Route path="/chart_of_accounts" element={<ChartOfAccounts />} />

        {access.salesHistoryAccess && (
          <>
            <Route path="/sales_history" element={<SalesHistory />} />
            <Route
              path="/sales_history/:customerId"
              element={<SalesHistory />}
            />
          </>
        )}

        {access.pos?.returnSale && (
          <Route
            path="/sell_return_form/:invoiceId"
            element={<SellReturnForm />}
          />
        )}

        {access.pos?.registerClosing && (
          <Route path="/close_reg" element={<CloseReg />} />
        )}

        {access.catalogAccess && (
          <>
            {access.catalog?.import && (
              <Route path="/import_catalog" element={<ImportCatalog />} />
            )}

            <Route path="/products" element={<Products />} />

            <Route path="/product_form">
              {access.catalog?.edit && (
                <Route path=":id" element={<AddEditProd />} />
              )}
              {access.catalog?.create && (
                <Route path="" element={<AddEditProd />} />
              )}
            </Route>
          </>
        )}

        {access.printLabelAccess && (
          <>
            <Route
              path="/print_label_history"
              element={<PrintLabelHistory />}
            />
            <Route path="/print_new_label" element={<PrintLabelForm />} />
          </>
        )}

        {access.supplierAccess && (
          <>
            <Route path="/suppliers" element={<Suppliers />} />
            <Route
              path="/view_supplier/:supplierId"
              element={<ViewSupplier />}
            />
            <Route path="/supplier_form">
              {access.supplier?.edit && (
                <Route path=":id" element={<AddEditSplr />} />
              )}
              {access.supplier?.create && (
                <Route path="" element={<AddEditSplr />} />
              )}
            </Route>
          </>
        )}

        {access.customerGroupAccess && (
          <Route path="/customer_groups" element={<Groups />} />
        )}

        {access.customerAccess && (
          <>
            <Route path="/customers" element={<Customers />} />
            <Route path="/view_customer/:id" element={<ViewCstmr />} />
            <Route path="/customer_form">
              {access.customer?.edit && (
                <Route path=":id" element={<AddEditCstmr />} />
              )}
              {access.customer?.create && (
                <Route path="" element={<AddEditCstmr />} />
              )}
            </Route>
          </>
        )}

        <Route path="/transfer_stock_form">
          <Route path=":id" element={<StockTransForm />} />
          <Route path="" element={<StockTransForm />} />
        </Route>

        {access.stockAccess && (
          <>
            <Route path="/order_stock_form">
              {access.stock?.edit && (
                <Route path=":id" element={<OrderAndReceiveForm />} />
              )}
              {access.stock?.create && (
                <Route path="" element={<OrderAndReceiveForm />} />
              )}
            </Route>
            {access.stock?.create && (
              <>
                <Route
                  path="/receive_stock_form"
                  element={<OrderAndReceiveForm isReceiveForm={true} />}
                />

                <Route
                  path="/receive_delivery_form/:id"
                  element={<ReceivedDeliveryForm />}
                />
              </>
            )}
          </>
        )}

        {access.supplierAccess && (
          <Route path="/supplier_form">
            {access.supplier?.edit && (
              <Route path=":id" element={<AddEditSplr />} />
            )}
            {access.supplier?.create && (
              <Route path="" element={<AddEditSplr />} />
            )}
          </Route>
        )}

        {access?.brandAccess && <Route path="/brands" element={<Brands />} />}
        {access?.productAttributeAccess && (
          <Route path="/product_attributes" element={<ProdAttrs />} />
        )}
        {access?.tagAccess && <Route path="/tags" element={<Tags />} />}
        {access?.categoryAccess && (
          <Route path="/product_category" element={<Categories />} />
        )}
        {access?.stockAccess && (
          <>
            <Route path="/stock_control" element={<Stocks />} />
            <Route path="/view_order/:id" element={<ViewOrder />} />
          </>
        )}

        {access.reportAccess && (
          <>
            <Route path="/profit_and_loss_report" element={<ProfitAndLoss />} />
            <Route
              path="/credit_customer_report"
              element={<CreditCustomer />}
            />
            <Route
              path="/product_movement_report"
              element={<ProductMovement />}
            />
            <Route path="/trial_balance_report" element={<TrialBalance />} />

            <Route path="/retail_dashboard" element={<RetailReport />} />
          </>
        )}

        {access?.generalAccess && (
          <Route path="/settings_form" element={<SettingsForm />} />
        )}

        {access?.outletAccess && (
          <>
            <Route path="/outlets" element={<Outlets />} />
            {access?.outlet?.register && (
              <Route path="/outlet/registers/:id" element={<Registers />} />
            )}
            <Route path="/outlet_form">
              {access.outlet?.edit && (
                <Route path=":id" element={<AddEditOutlet />} />
              )}
              {access.outlet?.create && (
                <Route path="" element={<AddEditOutlet />} />
              )}
            </Route>
          </>
        )}

        {access?.paymentTypeAccess && (
          <Route path="/payment_types" element={<PaymentTypes />} />
        )}
        {access?.currencyAccess && (
          <Route path="/currencies" element={<Currencies />} />
        )}
        {access?.taxRateAccess && <Route path="/taxes" element={<Taxes />} />}

        {access?.userAccess && (
          <>
            <Route path="/users" element={<Users />} />

            {access?.user?.ownAccountEdit && (
              <Route
                path="/edit_my_account/:id"
                element={<AddEditUser fromMyAcc={true} />}
              />
            )}

            <Route path="/user_form">
              {access?.user?.edit && (
                <Route path=":id" element={<AddEditUser />} />
              )}
              {access?.user?.create && (
                <Route path="" element={<AddEditUser />} />
              )}
            </Route>
          </>
        )}

        {access?.userRoleAccess && (
          <Route path="/user_roles" element={<UserRoles />} />
        )}

        <Route path="/special_orders" element={<SpecialOrders />} />
        <Route path="/special_order_form">
          <Route path=":id" element={<SpecialOrderForm />} />
          <Route path="" element={<SpecialOrderForm />} />
        </Route>

        {access?.stockReturnAccess && (
          <>
            <Route path="/return_stock" element={<StockReturns />} />
            <Route
              path="/view_return_stock/:id"
              element={<ViewReturnStock />}
            />
            {access?.stockReturn?.create && (
              <Route path="/stock_return_form">
                <Route path=":id" element={<StockReturnForm />} />
                <Route path="" element={<StockReturnForm />} />
              </Route>
            )}
          </>
        )}

        {access?.inqueryAccess && (
          <>
            <Route path="/inquiries" element={<Inquiries />} />
            <Route path="/view_inquiry/:id" element={<ViewInquiry />} />
            <Route path="/inquiry_form">
              {access?.inquery?.edit && (
                <Route path=":id" element={<AddEditInquiry />} />
              )}
              {access?.inquery?.create && (
                <Route path="" element={<AddEditInquiry />} />
              )}
            </Route>
          </>
        )}

        {access.followUpTypeAccess && (
          <Route path="/fullow_up_types" element={<FollowUpTypes />} />
        )}
        {access.inquerySourceAccess && (
          <Route path="/inquery_sources" element={<InquerySources />} />
        )}
      </Routes>
    </Dashboard>
  );
};

export default SiteRoute;
